<template>
  <div class="proposals-visual" aria-hidden="true">
    <div class="proposals-visual__toolbar">
      <span class="proposals-visual__title">Offertes</span>
      <span class="proposals-visual__subtitle">48 open</span>
      <span class="proposals-visual__search">Zoeken...</span>
      <span class="proposals-visual__button">Bulk versturen</span>
      <span class="proposals-visual__button proposals-visual__button--primary">
        Nieuwe offerte +
      </span>
    </div>

    <div class="proposals-visual__row proposals-visual__row--head">
      <span v-for="column in columns" :key="column.label" :class="column.class">
        {{ column.label }}
      </span>
    </div>

    <div v-for="proposal in proposals" :key="proposal.number" class="proposals-visual__row">
      <span class="proposals-visual__cell--number">{{ proposal.number }}</span>
      <span class="proposals-visual__cell--customer">
        <strong>{{ proposal.customer }}</strong>
        <small>{{ proposal.product }}</small>
      </span>
      <span class="proposals-visual__cell--type">
        <ShowcasePill :tone="proposal.type.tone">{{ proposal.type.label }}</ShowcasePill>
      </span>
      <span class="proposals-visual__cell--status">
        <ShowcasePill :tone="proposal.status.tone">{{ proposal.status.label }}</ShowcasePill>
      </span>
      <span class="proposals-visual__cell--amount">{{ proposal.amount }}</span>
      <span class="proposals-visual__cell--date">{{ proposal.date }}</span>
    </div>
  </div>
</template>

<script>
  import ShowcasePill from './ShowcasePill.vue';

  const PRO_FORMA = { label: 'PRO FORMA', tone: 'yellow' };
  const FINAL = { label: 'DEFINITIEF', tone: 'purple' };

  export default {
    name: 'ProposalsVisual',
    components: { ShowcasePill },
    setup() {
      const columns = [
        { label: 'NUMMER', class: 'proposals-visual__cell--number' },
        { label: 'KLANT', class: 'proposals-visual__cell--customer' },
        { label: 'TYPE', class: 'proposals-visual__cell--type' },
        { label: 'STATUS', class: 'proposals-visual__cell--status' },
        { label: 'BEDRAG EXCL.', class: 'proposals-visual__cell--amount' },
        { label: 'AANGEMAAKT', class: 'proposals-visual__cell--date' },
      ];

      const proposals = [
        {
          number: 'OF-1042',
          customer: 'Jan Drissen',
          product: '2x solar screen',
          type: PRO_FORMA,
          status: { label: 'BEKEKEN 2X', tone: 'green' },
          amount: '€ 3.423,97',
          date: '29 sep',
        },
        {
          number: 'OF-1041',
          customer: 'Fam. de Vries',
          product: 'Knikarmscherm 4000',
          type: FINAL,
          status: { label: 'VERSTUURD', tone: 'blue' },
          amount: '€ 12.380,00',
          date: '28 sep',
        },
        {
          number: 'OF-1040',
          customer: 'L. Mulder',
          product: '3x rolluik + scherm',
          type: FINAL,
          status: { label: 'GEACCEPTEERD', tone: 'green' },
          amount: '€ 5.400,00',
          date: '27 sep',
        },
        {
          number: 'OF-1039',
          customer: 'N. Hendriks',
          product: 'Pergola B800',
          type: PRO_FORMA,
          status: { label: 'NIET GEOPEND', tone: 'grey' },
          amount: '€ 14.720,00',
          date: '26 sep',
        },
        {
          number: 'OF-1038',
          customer: 'T. Bos',
          product: 'Insectenhor',
          type: PRO_FORMA,
          status: { label: 'CONCEPT', tone: 'grey' },
          amount: '€ 1.875,00',
          date: '26 sep',
        },
        {
          number: 'OF-1037',
          customer: 'S. Visser',
          product: '2x screen + motor',
          type: FINAL,
          status: { label: 'BEKEKEN 1X', tone: 'green' },
          amount: '€ 18.640,00',
          date: '25 sep',
        },
      ];

      return { columns, proposals };
    },
  };
</script>

<style scoped lang="scss">
  .proposals-visual {
    width: 1000px;
    padding: 20px 22px 8px;
    border: 1px solid var(--showcase-stroke);
    border-bottom: 0;
    border-radius: 10px 10px 0 0;
    background-color: var(--white);
    color: var(--showcase-ink);
    font-size: 13px;
    line-height: 20px;
    box-shadow:
      0 1px 2px rgba(0, 9, 33, 0.06),
      0 8px 24px rgba(0, 9, 33, 0.07);

    &__toolbar {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
    }

    &__title {
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
    }

    &__subtitle {
      flex: 1;
      color: var(--showcase-text);
    }

    &__search,
    &__button {
      padding: 3px 10px;
      border: 1px solid var(--showcase-stroke-button);
      border-radius: 6px;
      white-space: nowrap;
    }

    &__search {
      padding: 5px 10px;
      border-color: var(--showcase-stroke);
      color: var(--showcase-muted);
    }

    &__button--primary {
      border-color: var(--showcase-primary);
      background-color: var(--showcase-primary);
      color: var(--white);
    }

    &__row {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f0f1f5;
      > span {
        padding: 10px 8px;
        white-space: nowrap;
      }
      &:last-child {
        border-bottom: 0;
      }
      &--head {
        border-bottom-color: var(--showcase-stroke);
        > span {
          padding: 6px 8px;
          color: var(--showcase-muted);
          font-size: 10px;
          font-weight: 500;
          line-height: 15px;
          letter-spacing: 0.4px;
        }
      }
    }

    &__cell {
      &--number {
        flex: 0 0 90px;
        color: var(--showcase-muted);
      }
      &--customer {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-width: 0;
        strong {
          font-weight: 500;
        }
        small {
          color: var(--showcase-text);
          font-size: 12px;
          line-height: 18px;
        }
      }
      &--type {
        flex: 0 0 120px;
      }
      &--status {
        flex: 0 0 140px;
      }
      &--amount {
        flex: 0 0 120px;
        text-align: right;
        font-weight: 500;
      }
      &--date {
        flex: 0 0 110px;
        color: var(--showcase-text);
      }
    }
  }
</style>
